import useRequest from "~/composables/use-request";
import Event from "./events/event.model";

const RecommendationsAPI = {
  load(options: IRequestRecommendationOptions): Promise<IPaginatedResponse<IModelEvent>> {
    const { request } = useRequest();

    return request
      .get<IPaginatedResponse<IResponseEvent>>("/api/user/get_recommended", { query: options })
      .then(response => Event.formatPaginated(response, Event.format));
  },
};

export default RecommendationsAPI;
